import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative w-full py-20 md:py-24 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20abstract%20gradient%20background%20with%20soft%20overlapping%20circles%20in%20amber%20and%20coral%20tones%2C%20minimalist%20geometric%20design%2C%20smooth%20ethereal%20texture%2C%20cinematic%20lighting%20effect%2C%20clean%20modern%20aesthetic&width=1920&height=600&seq=cta-bg-home&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-primary-900/80 to-accent-900/70"></div>

      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-4xl font-bold text-background-50 font-heading mb-4">
          准备好开始探索了吗？
        </h2>
        <p className="text-sm md:text-base text-background-200 mb-8 max-w-xl mx-auto leading-relaxed">
          加入超过三百八十万用户的行列，在国产久久久发现您的下一个精彩内容。无论经典还是最新，我们都为您精选呈现。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/latest"
            className="px-8 py-3 rounded-full bg-background-50 text-primary-700 font-medium text-sm hover:bg-background-100 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            立即浏览
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 rounded-full border border-background-50/40 text-background-50 font-medium text-sm hover:bg-background-50/10 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}